import React, { useEffect } from 'react'
import useWebcam from '../../hooks/useWebcam'
import Button from '../ui/Button'
import styles from './WebcamCapture.module.css'

export default function WebcamCapture({ type, onCapture, onError }) {
  const { videoRef, error, isLoading, start, stop, capture } = useWebcam()

  useEffect(() => {
    start()
    return () => {
      stop()
    }
  }, [start, stop])

  useEffect(() => {
    if (error) {
      onError?.(error)
    }
  }, [error, onError])

  const handleCapture = async () => {
    const file = await capture()
    if (file) {
      onCapture?.(file)
    }
  }

  const isSelfie = type === 'selfie'

  return (
    <div className={styles.wrap}>
      <div className={styles.videoWrap}>
        <video
          ref={videoRef}
          autoPlay
          playsInline
          muted
          className={styles.video}
          aria-label="Camera preview"
        />
        <svg
          className={styles.overlay}
          viewBox="0 0 640 480"
          preserveAspectRatio="none"
          aria-hidden="true"
        >
          {isSelfie ? (
            <>
              <ellipse
                cx="320"
                cy="240"
                rx="140"
                ry="180"
                fill="none"
                stroke="rgba(255,255,255,0.8)"
                strokeWidth="3"
                strokeDasharray="8 4"
              />
              <text
                x="320"
                y="440"
                textAnchor="middle"
                fill="rgba(255,255,255,0.9)"
                fontSize="16"
                fontFamily="sans-serif"
              >
                Position your face here
              </text>
            </>
          ) : (
            <>
              <rect
                x="120"
                y="100"
                width="400"
                height="260"
                rx="8"
                fill="none"
                stroke="rgba(255,255,255,0.8)"
                strokeWidth="3"
                strokeDasharray="8 4"
              />
              <text
                x="320"
                y="400"
                textAnchor="middle"
                fill="rgba(255,255,255,0.9)"
                fontSize="16"
                fontFamily="sans-serif"
              >
                Position ID here
              </text>
            </>
          )}
        </svg>
      </div>
      <div className={styles.controls}>
        <Button onClick={handleCapture} size="lg" disabled={isLoading || !!error}>
          Capture
        </Button>
      </div>
    </div>
  )
}
